import React, { useEffect, useState, useContext, useRef } from 'react';
import { CreateNewSession, LoadSession, CreateNewCopyOfSession, getUserAndTaskIdExist, getSessionsFromTaskId, CreateTaskSession, CreateNewSessionWithGolfers } from '../isdlData/sessionData';
import { GetUser } from '../isdlData/matrixUserData';
import VenueList from './VenueList';
import UserList from './UserList';
import UserDisplay from './UserDisplay';
import Select from 'react-select';
import './Components.css';
import VenueDisplay from './VenueDisplay';
import { AppContext } from '../contexts/AppContext';
import ResumeTaskModal from './ResumeTaskModal';
import { Modal } from '@mui/material';
import { DialogContent } from '@mui/material';
import NewSessionTaskModal from './NewSessionTaskModal';
import { detectDeviceType, generateGUID } from '../utils/Utilities';
import BuildableGolferList from './BuildableGolferList';

function SessionStart({ dbInitialized, onLoadSession, onAttemptClose }) {

    const modalRef = useRef(null);
    const scrollRef = useRef(null);

    const [loading, setLoading] = useState(true);

    const [selectedGolfer, setSelectedGolfer] = useState(null);
    const [savedGolfer, setSavedGolfer] = useState('');

    const [selectedGolferList, setSelectedGolferList] = useState([]);

    const [selectedDC, setSelectedDC] = useState(null);
    const [savedDC, setSavedDC] = useState('');
    const [loggedDC, setLoggedDC] = useState(false);
    const [DCElevatedRole, setDCElevatedRole] = useState(false);

    const [selectedVenue, setSelectedVenue] = useState(null);
    const [savedVenue, setSavedVenue] = useState('');


    const [sessionName, setSessionName] = useState('');

    const [selectedMode, setSelectedMode] = useState("outdoor");

    const [selectedProjectId, setSelectedProjectId] = useState('');

    const [selectedTestId, setSelectedTestId] = useState('');

    const [useTaskId, setUseTaskId] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState("");
    const [validTaskId, setValidTaskId] = useState(false);
    const [taskIdConflictModalState, setTaskIdConflictModalState] = useState(false);
    const [taskIdConflictData, setTaskIdConflictData] = useState(null);
    const [taskIdConflictType, setTaskIdConflictType] = useState('NewUser');
    const [useSoundSession, setUseSoundSession] = useState(false);
    const [useMultiGolfers, setUseMultiGolfers] = useState(false);
    const taskIdCheckbox = useRef(null);
    const taskIdInput = useRef(null);

    const [resumeSessionModalState, setResumeSessionModalState] = useState(false);
    const [resumeSessionData, setResumeSessionData] = useState(null);
    const [resumeSessionDisplay, setResumeSessionDisplay] = useState('');

    const [newSessionValid, setNewSessionValid] = useState(false);
    const [existingSessionValid, setExistingSessionValid] = useState(false);
    const [resumeSessionValid, setResumeSessionValid] = useState(false);

    const [testTaskIdIsOpen, setTestTaskIdIsOpen] = useState(false);

    const [isMobile, setIsMobile] = useState(detectDeviceType() === "Mobile");


    // const [doubModalChecker, setModalChecker] = useState(false);
    let doubModalChecker = false;

    useEffect(() => {
        if (dbInitialized) {
            const loadUsers = async () => {
                const localSavedGolfer = localStorage.getItem('savedGolfer');
                const localSavedVenue = localStorage.getItem('savedVenue');

                if (localSavedGolfer && localSavedGolfer !== undefined && localSavedGolfer !== null) {
                    setSavedGolfer(localSavedGolfer);
                }

                if (localSavedVenue && localSavedVenue !== undefined && localSavedVenue !== null) {
                    setSavedVenue(localSavedVenue);
                }

                setLoading(false);
                validate();
            };

            loadUsers();
        }

        const handleBeforeUnload = () => {
            sessionStorage.removeItem('pushedResumeModal');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        if (dbInitialized) {
            // const localResumeSession = localStorage.getItem('savedLastSession');
            // const resumeSessionData = localResumeSession ? JSON.parse(localResumeSession) : {};
            // setResumeSessionData(resumeSessionData);

            // //Resume task modal
            // let pushResumeModal = localResumeSession != null;// init check with modal popup. Do we have data?

            // if(!doubModalChecker){
            //     doubModalChecker = true;
            //     if(sessionStorage.getItem('pushedResumeModal')){//We already pushed a modal popup...lets not do it again
            //         pushResumeModal = false;
            //     }

            //     if(pushResumeModal){//We haven't pushed a modal popup yet, lets make sure we don't do it again.
            //         sessionStorage.setItem('pushedResumeModal', true);
            //     }

            //     setResumeSessionModalState(pushResumeModal);//Push modal or don't push it.
            // }
        }

        return () => {
            setSessionName('');
            window.removeEventListener('beforeunload', handleBeforeUnload);
        }
    }, [dbInitialized]);

    useEffect(() => {

        validate();

    }, [selectedDC, selectedGolfer, selectedVenue, selectedTaskId, useTaskId, sessionName, selectedGolferList]);

    useEffect(() => {
        if (resumeSessionData === null || resumeSessionData === undefined) {
            setResumeSessionDisplay('Current Task: N/A');
            return;
        }

        if (resumeSessionData["Id"] === null || resumeSessionData["Id"] === undefined) {
            setResumeSessionDisplay('Current Task: N/A');
            return;
        }

        const session_id = resumeSessionData["Id"] != null ? resumeSessionData["Id"].toString() : "";
        const session_description = resumeSessionData["Description"] != null ? resumeSessionData["Description"].toString() : "";
        const session_date = resumeSessionData["Date"] != null ? resumeSessionData["Date"].toString() : "";
        const session_task = resumeSessionData["TaskID"] != null ? resumeSessionData["TaskID"].toString() : "";
        const session_project = resumeSessionData["ProjectId"] != null ? resumeSessionData["ProjectId"].toString() : "";
        let display = "";

        if (!session_description && !session_task && !session_project) {
            display = session_date;
        } else if (session_description) {
            display = session_description;
            if (session_task) {
                display += ` (${session_task})`;
            } else if (session_project) {
                display += ` (${session_project})`;
            }
        } else if (session_task) {
            display = session_task;
            if (session_project) {
                display += ` (${session_project})`;
            }
        }

        setResumeSessionDisplay("Current Task:\n" + display);

    }, [resumeSessionData]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(detectDeviceType() === "Mobile");
        };

        window.debugDC = (dc) => {
            let finalDC = dc === null || dc === undefined ? '' : dc;
            loadLoginDCEmail(finalDC);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            delete window.debugDC;
        }
    }, []);

    useEffect(() => {

        const dcemail = sessionStorage.getItem('dataCollectorEmail');

        loadLoginDCEmail({ user: dcemail });
        // window.addEventListener('usesApp', parseAppLoginData);

        return () => window.removeEventListener('usesApp', parseAppLoginData);
    }, []);

    function parseAppLoginData(data) {
        loadLoginDCEmail(data.detail);
    }

    async function loadLoginDCEmail(data) {
        const dcemail = data.user;

        if (dcemail && isEmailCleanable(dcemail)) {
            const cleanedEmail = cleanEmail(dcemail);

            const userData = await GetUser(cleanedEmail.toLowerCase());
            setSavedDC(cleanedEmail.toLowerCase());
            if (userData.Role === "Admin"||userData.Role === "DataCollector") {
                setLoggedDC(false);
            } else {
                setLoggedDC(true);
            }
        } else {
            setLoggedDC(false);

        }
    }

    function isEmailCleanable(email) {
        // Regex to check if the email contains 'corp.' in the subdomain
        const corpDomainRegex = /^([^@]+)@corp\.(.+)$/;

        // Test if the email has 'corp.' in the domain part
        return corpDomainRegex.test(email);
    }

    function cleanEmail(email) {
        if (isEmailCleanable(email)) {
            // Remove 'corp.' from the domain
            return email.replace('corp.', '');
        }
        return email; // Return the original email if it's not cleanable
    }

    const handleStartSession = async () => {

        if (validTaskId) {
            const matchingTaskUserSessions = await Promise.all(
                selectedGolferList.map(golfer => getUserAndTaskIdExist(golfer.id, selectedTaskId))
            );

            const validMatches = matchingTaskUserSessions
                .map((session, index) => (Array.isArray(session) && session.length > 0)
                    ? { Golfer: selectedGolferList[index], Session: session[0] }
                    : null
                )
                .filter(Boolean);

            if (validMatches.length > 0) {
                setTaskIdConflictData(validMatches[0]);
                setTaskIdConflictType('SameUser');
                setTaskIdConflictModalState(true);
                return;
            }

            const potentialMatchingSessions = await getSessionsFromTaskId(selectedTaskId);
            const matchingSessions = Array.isArray(potentialMatchingSessions) ? potentialMatchingSessions : [potentialMatchingSessions];

            if (matchingSessions?.length > 0) {
                setTaskIdConflictData(matchingSessions[0]);
                setTaskIdConflictType('NewUser');
                setTaskIdConflictModalState(true);
            }
        }

        if (newSessionValid) {

            if (useTaskId || useMultiGolfers) {

                const fTaskId = useTaskId ? selectedTaskId : generateGUID();

                const newSessionData =
                {
                    DataCollector: selectedDC,
                    // Golfer:selectedGolfer,
                    Description: sessionName,
                    Venue: selectedVenue,
                    Mode: selectedMode,
                    ProjectId: selectedProjectId,
                    TestId: selectedTestId,
                    TaskId: fTaskId,
                }
                await CreateNewSessionWithGolfers(newSessionData, selectedGolferList);
                SaveSelectedGolfer(selectedGolfer);
                SaveSelectedVenue(selectedVenue);
                onLoadSession(null, "MAINWINDOW");
            } else {
                const newSessionData =
                {
                    DataCollector: selectedDC,
                    Golfer: selectedGolfer,
                    Description: sessionName,
                    Venue: selectedVenue,
                    Mode: selectedMode,
                    ProjectId: selectedProjectId,
                    TestId: selectedTestId,
                    TaskId: selectedTaskId,
                    SoundSession: useSoundSession
                }
                await CreateNewSession(newSessionData);
                // SaveSelectedDC(selectedDC);
                SaveSelectedGolfer(selectedGolfer);
                SaveSelectedVenue(selectedVenue);
                onLoadSession(null, "MAINWINDOW");
            }

        }
    };

    const handleResumeSession = async () => {
        const session_id = resumeSessionData["Id"] != null ? resumeSessionData["Id"].toString() : "";

        if (session_id) {
            await LoadSession(session_id);
            onLoadSession(null, "MAINWINDOW");
        }
    }

    const handleTaskSetup = async (data) => {
        const taskId = data.taskId;
        const taskData = data.taskData;
        const golfers = data.golfers;
        const dataCollector = data.dataCollector;
        const venue = data.venue;

        await CreateTaskSession(taskId, taskData, golfers, dataCollector, venue);

        onLoadSession(null, "MAINWINDOW");
    }

    const handleVenueChange = (venue) => {
        setSelectedVenue(venue);
        SaveSelectedVenue(venue);
        // validate();
    }

    const handleGolferChange = (user) => {
        setSelectedGolfer(user);
        SaveSelectedGolfer(user);
        // validate();
    }

    const handleDCChange = (user) => {
        setSelectedDC(user);

        setDCElevatedRole((user.Role === 'Admin' || user.Role === 'Fitter'|| user.Role === "DataCollector"));

        // SaveSelectedDC(user);
        // validate();
    }

    // function SaveSelectedDC(){
    //     localStorage.setItem('savedDC',selectedDC.id);
    // }

    // function SaveSelectedDC(user){
    //     localStorage.setItem('savedDC',user.id);
    // }

    function SaveSelectedGolfer() {
        localStorage.setItem('savedGolfer', selectedGolfer.id);
    }

    function SaveSelectedGolfer(user) {
        if (user === null) {
            localStorage.clear('savedGolfer');
        } else {
            localStorage.setItem('savedGolfer', user.id);
        }
    }

    function SaveSelectedVenue() {
        localStorage.setItem('savedVenue', selectedVenue.Name);
    }

    function SaveSelectedVenue(venue) {
        if (venue) {
            localStorage.setItem('savedVenue', venue.Name);
        } else {
            localStorage.removeItem('savedVenue');
        }
    }

    const handleTaskIdInput = (e) => {
        const regex = /^\d{4}-\d{5,6}-\d{2}$/;
        const inputValue = e.target.value;


        // Check if the input matches the regex pattern or is empty
        if (regex.test(inputValue) || inputValue === '') {
            setValidTaskId(true);
            setSelectedTaskId(inputValue);
        } else {
            setValidTaskId(false);
            setSelectedTaskId('');
        }
    };

    const handleSoundSessionCheck = (e) => {

    }

    function validate() {
        validateNewSessionButton();
        validateExistingSessionButton();
        validateResumeSessionButton();
    }

    function validateNewSessionButton() {
        let valid = true;

        // if(!dbInitialized){
        //     valid = false;
        // }

        if (sessionName === null || sessionName === undefined || sessionName === '') {
            valid = false;
        }

        if(useTaskId || useMultiGolfers){
            if (selectedGolferList === null || selectedGolferList === undefined || selectedGolferList.length === 0) {
                valid = false;
            }
        }else{
            if (selectedGolfer === null || selectedGolfer === undefined) {
                valid = false;
            }
        }


        if (selectedDC === null || selectedDC === undefined) {
            valid = false;
        }

        if (selectedVenue === null || selectedVenue === undefined) {
            valid = false;
        }

        // if(useTaskId && !validTaskId){
        //     valid = false;
        // }

        setNewSessionValid(valid);
    }

    function validateExistingSessionButton() {
        let valid = true;

        if (!dbInitialized) {
            valid = false;
        }

        if (selectedDC === null || selectedDC === undefined) {
            valid = false;
        }

        setExistingSessionValid(valid);
    }

    function validateResumeSessionButton() {
        let valid = true;

        if (!dbInitialized) {
            valid = false;
        }

        if (resumeSessionData === null || resumeSessionData === undefined || resumeSessionData["Id"] === null || resumeSessionData["Id"] === undefined) {
            valid = false;
        }

        setResumeSessionValid(valid);
    }

    const ValidateTaskId = () => {
        if (useTaskId && validTaskId) {
            return true;
        } else if (!useTaskId) {
            return true;
        } else {
            return false;
        }
    }

    const TaskIdConflictHandler = async (shouldLoad) => {
        setTaskIdConflictModalState(false);

        if (shouldLoad) {
            switch (taskIdConflictType) {
                case "NewUser":
                    await CreateNewCopyOfSession(selectedGolfer, taskIdConflictData);
                    onLoadSession(null, "MAINWINDOW");
                    setTaskIdConflictData(null);
                    break;
                case "SameUser":
                    await LoadSession(taskIdConflictData.Session.id);
                    onLoadSession(null, "MAINWINDOW");
                    setTaskIdConflictData(null);
                    break;
            }
        } else {
            taskIdCheckbox.current.checked = false;
            taskIdInput.current.value = '';
            taskIdInput.current.disabled = true;
            setTaskIdConflictData(null);
        }
    }

    const handleGolferListChange = (golfers) => {
        setSelectedGolferList(golfers);
    }

    return (
        <div className="container" ref={modalRef} style={{ justifyContent: 'start', alignContent:'center' }}>
            <div style={{ width: '100%', height: '80px', flexShrink:'0' }} />
            <div style={{ height: '100%', overflow: 'auto', width:'100%', maxWidth:'1024px', flexGrow:'1', alignItems:'center', display:'flex', flexDirection:'column'}} ref={scrollRef}>
                <div style={{ width: 'calc(100% - 40px)', maxWidth: '1024px', height: 'auto' }}>
                    <div style={{ width: '100%' }}>
                        <div className="start-input-container" >
                            <label htmlFor="descriptionInput" style={{ textAlign: 'center', width: '120px', alignContent: 'center', flexShrink: '0'  }}>
                                Description
                            </label>
                            <input
                                style={{ width: '100%' }}
                                id="descriptionInput"
                                className="input"
                                type="text"
                                value={sessionName}
                                onChange={(e) => setSessionName(e.target.value)}
                            />
                        </div>

                        <div className='start-settings-container' style={{justifyContent:'start', gap:'0'}}>
                            <label htmlFor="projectInput" style={{ textAlign: 'center', width: '120px', alignContent: 'center', flexShrink: '0' }}>
                                Project
                            </label>
                            <div className="start-input-container" style={{ flex:'1'}}>

                                <input
                                    style={{ width: '100%' }}
                                    id="projectInput"
                                    className="input"
                                    type="text"
                                    value={selectedProjectId}
                                    onChange={(e) => setSelectedProjectId(e.target.value)}
                                />
                            </div>
                            <label htmlFor="testInput" style={{ textAlign: 'center', width: '120px', alignContent: 'center', flexShrink: '0'  }}>
                                Test
                            </label>
                            <div className="start-input-container" style={{ flex:'1'}}>

                                <input
                                    style={{ width: '100%' }}
                                    id="testInput"
                                    className="input"
                                    type="text"
                                    value={selectedTestId}
                                    onChange={(e) => setSelectedTestId(e.target.value)}
                                />
                            </div>
                        </div>
                        
                        <div className="start-input-container">
                            <input
                                style={{ marginLeft: '120px', height: '20px', width:'20px', alignSelf:'center' }}
                                id="useWorkIdInput"
                                type="checkbox"
                                value={useTaskId}
                                disabled={useMultiGolfers}
                                onChange={(e) => setUseTaskId(e.target.checked)}
                                ref={taskIdCheckbox}
                            />
                            <label htmlFor="useWorkIdInput" style={{ textAlign: 'start', width: '100%', alignContent: 'center' }}>
                                Use Work Order TaskID
                            </label>
                        </div>

                        <div className="start-input-container">
                            <label htmlFor="taskIdInput" style={{ textAlign: 'center', width: '120px', alignContent: 'center', flexShrink: '0' }}>
                                Task Id
                            </label>
                            <input
                                disabled={!useTaskId}
                                style={{ width: '100%', outline: ValidateTaskId() ? "0" : "2px solid red" }}
                                id="taskIdInput"
                                className="input"
                                type="text"
                                maxLength="14"
                                ref={taskIdInput}
                                onChange={handleTaskIdInput}
                            />
                        </div>
                        <div className='start-settings-container'>
                            <div className="start-settings-item">
                                <label htmlFor="soundSessionInput" style={{ textAlign: 'center', width: '120px', alignContent: 'center' }}>
                                    Sound Session
                                </label>
                                <input
                                    style={{ height: '20px', width: '20px', alignSelf: 'center' }}
                                    id="soundSessionInput"
                                    type="checkbox"
                                    maxLength="14"
                                    value={useSoundSession}
                                    ref={taskIdInput}
                                    onChange={(e) => setUseSoundSession(e.target.checked)}
                                />
                            </div>
                            <div className="start-settings-item">
                                <label htmlFor="multiGolferInput" style={{ textAlign: 'center', width: '140px', alignContent: 'center' }}>
                                    Multiple Golfers
                                </label>
                                <input
                                    style={{ height: '20px', width: '20px', alignSelf: 'center' }}
                                    id="multiGolferInput"
                                    type="checkbox"
                                    maxLength="14"
                                    disabled={useTaskId}
                                    value={useMultiGolfers}
                                    ref={taskIdInput}
                                    onChange={(e) => setUseMultiGolfers(e.target.checked)}
                                />
                            </div>
                            <div className="start-settings-item">
                                <label style={{ textAlign: 'center', width: '60px', alignContent: 'center' }}>
                                    Mode
                                </label>
                                <div style={{ display: 'flex', flexDirection: 'row', alignContent:'space-evenly' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignContent:'space-evenly' }}>
                                        <input id='outdoor' type='radio' name='lmmode' style={{ width: '20px', height: '20px', transform: 'translateY(8px)' }} checked={selectedMode === "outdoor"} onChange={(e) => setSelectedMode("outdoor")} />
                                        <label htmlFor='outdoor' style={{ textAlign: 'center', alignContent: 'center', marginLeft: '5px', marginRight: '20px' }}>Outdoor</label>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignContent:'space-evenly' }}>
                                        <input id='indoor' type='radio' name='lmmode' style={{ width: '20px', height: '20px', transform: 'translateY(8px)' }} checked={selectedMode === "indoor"} onChange={(e) => setSelectedMode("indoor")} />
                                        <label htmlFor='indoor' style={{ textAlign: 'center', alignContent: 'center', marginLeft: '5px', marginRight: '10px' }}>Indoor</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', width: 'calc(100% - 40px)', height: 'calc(100% - 270px)' }}>
                    {/* Golfer Column */}
                    <div className='start-selector-container'>
                        <div className='start-selector-container-header'>{(useTaskId || useMultiGolfers) ? "Golfers" : "Golfer"}</div>
                        {(useTaskId || useMultiGolfers) ? (
                            <>
                                <BuildableGolferList ModalRef={modalRef} ScrollRef={scrollRef} ListUpdated={handleGolferListChange} GolferList={selectedGolferList} />
                            </>
                        ) : (
                            <>
                                <UserList dbInitialized={dbInitialized} UserChanged={handleGolferChange} LoadedUser={savedGolfer} HasEditPermission={DCElevatedRole} />
                            </>
                        )}
                        {/* <div>
                    <strong>
                        Golfer Selected:
                    </strong>
                </div>
                <UserDisplay User={selectedGolfer} /> */}
                    </div>
                    {/* Data Collector Section */}
                    <div className='start-selector-container'>
                        <div className='start-selector-container-header'>Data Collector</div>
                        <UserList dbInitialized={dbInitialized} UserChanged={handleDCChange} Disabled={loggedDC} LoadedUser={savedDC} HasEditPermission={DCElevatedRole} />
                        <div hidden={!loggedDC}>
                            <UserDisplay User={selectedDC} />
                        </div>
                    </div>
                    {/* Venue Section */}
                    <div className='start-selector-container'>
                        <div className='start-selector-container-header'>Venue</div>
                        <VenueList dbInitialized={dbInitialized} VenueChanged={handleVenueChange} LoadedVenue={savedVenue} />
                        {/* <div>
                    <strong>
                        Venue Selected:
                    </strong>
                </div>
                <VenueDisplay Venue={selectedVenue} /> */}
                    </div>
                </div>
            </div>
            <div className="modal-footer" style={{ flexShrink: '0' }}>
                <button id="startSessionButton" className="button" disabled={!newSessionValid} onClick={handleStartSession}>
                    Start session
                </button>
            </div>
            <Modal
                open={resumeSessionModalState}>
                <ResumeTaskModal ResumeTaskDisplay={resumeSessionDisplay} CancelResumeTask={() => setResumeSessionModalState(false)} HandleResumeTask={handleResumeSession} />
            </Modal>
            <Modal
                open={taskIdConflictModalState}>
                <NewSessionTaskModal ConflictType={taskIdConflictType} TaskId={selectedTaskId} ConflictData={taskIdConflictData} NewSessionTaskModalResult={TaskIdConflictHandler} />
            </Modal>
        </div>
    );
}

export default SessionStart;